import debounce from 'lodash/debounce';
import { useEffect, useState, useCallback, useRef } from 'react';

const useInputMutex = ({ defaultValue = null, callback, minSearchValueLength, maxRequestRate, compareLast = true }) => {
  const [value, setValue] = useState(defaultValue || '');
  const [lastValue, setLastValue] = useState('');
  const isMountedRef = useRef(true);

  // Cleanup function to prevent operations on unmounted component
  useEffect(
    () => () => {
      isMountedRef.current = false;
    },
    [],
  );

  const debounceCallback = useCallback(
    debounce((data) => {
      if (callback && isMountedRef.current) callback(data);
    }, maxRequestRate),
    [callback, maxRequestRate],
  );

  useEffect(() => {
    let isSearch = (value.length >= minSearchValueLength || value.length === 0) && value !== defaultValue;

    if (compareLast) {
      isSearch = value !== lastValue;
      if (isSearch && isMountedRef.current) setLastValue(value);
    }

    if (isSearch) {
      debounceCallback(value);
    }
  }, [value, defaultValue, minSearchValueLength, maxRequestRate, debounceCallback, lastValue, compareLast]);

  return [value, setValue];
};

export default useInputMutex;
